


































import Vue from "vue";

export default Vue.extend({
  name: "QuickEntry",
  props: {
    slidesPerView: {
      type: Number,
      required: true,
    },
  },
});
